import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { isDefined } from '@fi-shared/utils';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FiChipsSelectSearchComponent } from '@fi-shared/fi-select-search/fi-chips-select-search/fi-chips-select-search.component';

@Component({
    selector: 'fi-chips-group-options-select-search',
    templateUrl: './fi-chips-group-options-select-search.component.html',
    styleUrls: ['../fi-chips-select-search.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-chips-group-options-select-search' },
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FiChipsGroupOptionsSelectSearchComponent,
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: FiChipsGroupOptionsSelectSearchComponent,
            multi: true,
        },
    ],
    standalone: false,
})
export class FiChipsGroupOptionsSelectSearchComponent<T, TRes = T>
    extends FiChipsSelectSearchComponent<T, TRes>
    implements OnInit
{
    @Input() groups: any[] = [];
    @Input() groupItemsPropertyName: string = '';
    @Input() groupNamePropertyName: string = '';
    @Input() trackByFn: (item: T) => TRes = (item) => <any>item;
    @Input() getGroupItemClassNameFn: (item: T) => { [key: string]: boolean } = () => undefined;

    groupData: {
        name: string;
        items$: Observable<T[]>;
    }[] = [];

    ngOnInit(): void {
        this.setGroupData();
        super.ngOnInit();
        this.updateFilteredItems();
    }

    private setGroupData() {
        this.groups.forEach((group) => {
            const groupItems: T[] = group[this.groupItemsPropertyName];
            this.items = [...this.items, ...groupItems];

            this.groupData.push({
                name: group[this.groupNamePropertyName],
                items$: this.filteredItems$.pipe(takeUntil(this.ngOnDestroy$)).pipe(
                    map((items) => {
                        return items.filter((item) => groupItems.indexOf(item) !== -1);
                    }),
                ),
            });
            this.updateSelectedItemsFromModel();
        });
    }
}
